import { serializeJsonLd } from './serializeJsonLd';
import type { JsonLdObject } from './types';

export const JSON_LD_SCRIPT_ID = 'structured-data';

interface JsonLdProps {
    data?: JsonLdObject;
    id?: string;
}

export const JsonLd = ({ data, id = JSON_LD_SCRIPT_ID }: JsonLdProps) => {
    if (!data) {
        return null;
    }

    return (
        <script
            id={id}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: serializeJsonLd(data) }}
        />
    );
};
